import {
  LOG_OUT,
  RESEND_FAILD,
  RESEND_LOADING,
  RESEND_SUCCESS,
  RESET_RESEND_OTP
} from "../types";

const initialState = {
  loading: false,
  error: null,
  otpMessage: null,
};

export const resendOtpReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case RESEND_LOADING:
      return {
        ...state,
        loading: action.loading,
        otpMessage: null,
        error: null,
      };
    case RESEND_SUCCESS:
      return {
        ...state,
        loading: false,
        otpMessage: action.payload,
        error: null,
      };
    case RESEND_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case RESET_RESEND_OTP:
      return initialState;

    case LOG_OUT:
      return {
        ...state,
        loading: false,
        error: null,
        otpMessage: null,
      };

    default:
      return state;
  }
};
